import { Printer, Cpu, LayoutGrid, Bot, Plane, Car, Boxes, Rocket, ShieldCheck, Zap, Sparkles } from "lucide-react";
import { Link } from "react-router-dom";


const machines = [
  { label: "3D Print", icon: Printer, bg: "from-sky-400 to-blue-500" },
  { label: "CNC", icon: Cpu, bg: "from-indigo-400 to-indigo-600" },
  { label: "PCB", icon: LayoutGrid, bg: "from-sky-400 to-cyan-500" },
  { label: "Robotics", icon: Bot, bg: "from-pink-400 to-fuchsia-600" },
  { label: "Drone", icon: Plane, bg: "from-blue-400 to-indigo-600" },
  { label: "EV", icon: Car, bg: "from-orange-400 to-rose-500" },
  { label: "CAD", icon: Boxes, bg: "from-fuchsia-400 to-purple-600" },
  { label: "Launch", icon: Rocket, bg: "from-amber-400 to-orange-500" },
];

export default function Hero() {
  return (
    <section className="relative bg-gradient-to-br from-[#1e1b4b] via-[#312e81] to-[#4c1d95] text-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 py-20 grid lg:grid-cols-2 gap-12 items-center relative">
        {/* Left column */}
        <div>
          <span className="inline-flex items-center gap-2 text-xs font-medium bg-white/10 border border-white/20 rounded-full px-4 py-1.5 mb-6">
            <Sparkles className="w-3.5 h-3.5" />
            Government of Andhra Pradesh · Innovation Ecosystem
          </span>

          <h1 className="text-5xl md:text-6xl font-extrabold leading-tight mb-6">
            Turn Your Ideas <br />
            <span className="bg-gradient-to-r from-teal-300 via-yellow-200 to-orange-400 bg-clip-text text-transparent">
              Into Reality.
            </span>
          </h1>

          <p className="text-indigo-100 text-lg max-w-xl mb-8">
            Access advanced prototyping infrastructure, machines, experts
            and innovation facilities across Andhra Pradesh — all through
            one digital platform.
          </p>

          <div className="flex flex-wrap gap-4 mb-8">

            <Link to="/register" className="flex items-center gap-2 bg-white text-indigo-900 font-semibold px-6 py-3 rounded-xl hover:bg-gray-100 transition">
              Start Your Prototype →
            </Link>

            <Link to="/facilities"
              className="flex items-center gap-2 border border-white/30 font-semibold px-6 py-3 rounded-xl hover:bg-white/10 transition"
            >
              Explore APIC Facilities
            </Link>
          </div>

          <div className="flex flex-wrap gap-6 text-sm text-indigo-200">
            <span className="flex items-center gap-2">
              <ShieldCheck className="w-4 h-4" /> ISO 9001 Certified Centres
            </span>
            <span className="flex items-center gap-2">
              <Zap className="w-4 h-4" /> 24hr Quotation Turnaround
            </span>
          </div>
        </div>

        {/* Right column - machine grid + live build card */}
        <div className="relative">
          <div className="grid grid-cols-3 gap-4">
            {machines.map(({ label, icon: Icon, bg }) => (
              <div
                key={label}
                className="bg-white/10 border border-white/10 rounded-2xl p-5 flex flex-col items-center justify-center gap-3 hover:bg-white/15 transition"
              >
                <div className={`w-10 h-10 rounded-full bg-gradient-to-br ${bg} flex items-center justify-center`}>
                  <Icon className="w-5 h-5 text-white" />
                </div>
                <span className="text-sm font-medium">{label}</span>
              </div>
            ))}
          </div>

          {/* Live build card */}
          <div className="absolute -bottom-8 -left-6 bg-white text-gray-900 rounded-2xl shadow-2xl p-5 w-72">
            <div className="flex items-center justify-between mb-2">
              <span className="text-xs font-semibold text-gray-500">LIVE BUILD</span>
              <span className="flex items-center gap-1 text-xs font-medium text-green-600">
                <span className="w-2 h-2 rounded-full bg-green-500" /> Running
              </span>
            </div>
            <p className="font-bold mb-1">EV Battery Enclosure</p>
            <p className="text-sm text-gray-500 mb-3">
              APIC Visakhapatnam · 5-Axis CNC
            </p>
            <div className="w-full h-2 bg-gray-100 rounded-full overflow-hidden mb-2">
              <div className="h-full w-[62%] bg-gradient-to-r from-indigo-500 to-purple-500 rounded-full" />
            </div>
            <p className="text-xs text-gray-500">62% · ETA Nov 28</p>
          </div>
        </div>
      </div>
    </section>
  );
}